"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.capitalizeFirstLetter = void 0;
const capitalizeFirstLetter = (value) => value.replace(/^[^a-zа-яё]*([a-zа-яё])/i, (str) => str.toUpperCase());
exports.capitalizeFirstLetter = capitalizeFirstLetter;
